type ApiErrorWithErrors = { data?: { errors?: Record<string, string> } };

/**
 * Extracts error keys from an API error response and returns translated messages.
 * Expects errors under error.data.errors as key-value pairs; each value is treated as a translation key
 * under default.errors (e.g. key "projectCrewTicketType.amount.lessThanAssigned" → t("default.errors.projectCrewTicketType.amount.lessThanAssigned")).
 * If no keys are found, returns a single message using the fallback key.
 */
export function getTranslatedApiErrorMessages(
    error: ApiErrorWithErrors | undefined | null,
    t: (key: string) => string,
    fallbackKey = 'default.serverError'
): string[] {
    const errors = error?.data?.errors;
    const keys =
        typeof errors === 'object' && errors !== null
            ? (Object.values(errors).filter((v) => typeof v === 'string') as string[])
            : [];
    return keys.length ? keys.map((key) => t(`default.errors.${key}`)) : [t(fallbackKey)];
}
